import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UBXGridModule } from '../grid/grid.module';
import { UBXIconModule } from '../icon/icon.module';
import { UBXToastComponent } from './toast.component';
import { UBXToastSliceComponent } from './slice/toast-slice.component';

const Imports = [
    UBXGridModule,
    UBXIconModule,
];
const Module = [
    UBXToastComponent,
    UBXToastSliceComponent,
];

@NgModule({
    declarations: [
        Module
    ],
    imports: [
        CommonModule,
        Imports
    ],
    exports: [
        Module
    ],
})
export class UBXToastModule {}
